import { Link } from "@tanstack/react-router";

interface InlineAppointmentCTAProps {
  heading?: string;
  body?: string;
  buttonText?: string;
  /**
   * Primary CTA destination. Defaults to /appointments so existing usages
   * keep their current behavior.
   */
  to?: string;
  secondaryButton?: { text: string; to: string; hash?: string } | null;
  /**
   * @deprecated The mid-page vs bottom-only placement experiment has ended.
   * This prop is kept for compatibility and no longer affects visibility.
   */
  experiment?: boolean;
}

export function InlineAppointmentCTA({
  heading = "Ready to take the next step?",
  body = "Schedule a consultation with Dr. Fitzer to discuss your options and find the approach that fits your goals.",
  buttonText = "Schedule an Appointment",
  to = "/appointments",
  secondaryButton = null,
}: InlineAppointmentCTAProps) {
  return (
    <aside className="my-8 rounded-2xl border border-border bg-brand-soft/30 p-5 sm:p-6 text-center shadow-sm">
      <h2 className="text-[1.25rem] sm:text-[1.35rem] md:text-[1.6875rem] font-serif text-brand-deep">
        {heading}
      </h2>
      <p className="mt-2 text-foreground/80 max-w-2xl mx-auto text-sm sm:text-base">
        {body}
      </p>
      <div className="mt-5 flex flex-col sm:flex-row justify-center gap-3">
        <Link
          to={to}
          className="rounded-full bg-primary px-6 py-3.5 text-base font-medium text-primary-foreground hover:opacity-90 text-center w-full sm:w-auto min-h-[48px] inline-flex items-center justify-center"
        >
          {buttonText}
        </Link>
        {secondaryButton && (
          <Link
            to={secondaryButton.to}
            hash={secondaryButton.hash}
            className="rounded-full border border-brand-deep px-6 py-3.5 text-base font-medium text-brand-deep hover:bg-brand-deep/5 text-center w-full sm:w-auto min-h-[48px] inline-flex items-center justify-center"
          >
            {secondaryButton.text}
          </Link>
        )}
      </div>
    </aside>
  );
}
